import React from 'react';
import numeral from 'numeral';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Divider from '@mui/material/Divider';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  },
  container: {
    maxHeight: 440
  },
  divider: {
    marginTop: 40,
    marginBottom: 20
  }
});

const DataTableComponent = ({ resultSet }) => {
  const classes = useStyles();

  const getHeaders = () => {
    const { dimensions, measures } = resultSet.loadResponse.annotation;
    const { data } = resultSet.loadResponse;
    const headerKeys = Object.keys(data[0]);
    return headerKeys.map(key => {
      if (dimensions[key]) {
        return dimensions[key].title;
      }
      if (measures[key]) {
        return measures[key].title;
      }
      return key;
    });
  };

  const getRows = () => {
    const { data } = resultSet.loadResponse;
    return data.map(item => Object.values(item));
  };

  if (
    resultSet &&
    resultSet.loadResponse.data &&
    resultSet.loadResponse.data.length > 0
  ) {
    const headers = getHeaders();
    const rows = getRows();

    return (
      <TableContainer className={classes.container}>
        <Table className={classes.table} stickyHeader>
          <TableHead>
            <TableRow>
              {headers.map(title => (
                <TableCell key="title" align="left">
                  {title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.name}>
                {row.map(cell => (
                  <TableCell key={cell} align="left">
                    {/* eslint-disable-next-line */}
                    {isNaN(cell)
                      ? cell
                      : numeral(Math.round(cell)).format(0, 0)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  return (
    <p>
      <Divider className={classes.divider} variant="middle" />
      <h3>No data yet</h3>
    </p>
  );
};

export default DataTableComponent;
